const { GET_CART, QUANTITY_CHANGED, SET_CART, CATEGORY_NAV, PROMOTIONS_QUANTITY } = require("redux/constants/Cart");
const { setLocalStorageCart } = require("utils/cart");

const initState = {
    cart : [],
    cartQuantity : 0,
    navClicked: {element: "", index: ""},
    homePromotion: {},
}

const CartReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_CART:
            return {
                cart : setLocalStorageCart(),
            }
        case SET_CART:
            return {
                ...state,
                cartQuantity : action.payload
            }
        case QUANTITY_CHANGED:
            return {
                ...state,
                cartQuantity: state.cartQuantity = state.cartQuantity + action.payload
            }
        case CATEGORY_NAV:
            return {
                ...state,
                navClicked : action?.payload,
            }
        case PROMOTIONS_QUANTITY:
            return {
                ...state,
                homePromotion: action?.payload,
            }
        default:
            return state;
    }
}

export default CartReducer;